import cookies from 'react-cookies';
import { batch } from 'react-redux';
import { captureException } from '@sentry/node';
import dayjs from 'dayjs';

import { PROVIDER_ID_COOKIE } from '@r1-frontend/service-engineer-visit/constants';
import { TContextDispatch } from '@r1-frontend/service-engineer-visit/context/Context';
import { dataLayerPush, transformTimeSlots } from '@r1-frontend/service-engineer-visit/helpers';
import { TInitialState } from '@r1-frontend/service-engineer-visit/reducer/initialState';
import getBodyForTimeSlotsRequest from '@r1-frontend/service-engineer-visit/selectors/getBodyForTimeSlotsRequest';
import { TGetTimeSlots } from '@r1-frontend/service-engineer-visit/types/TGetTimeSlots';

import { requestSlots as requestSlotsAction, setErrorMessage, setIsLoading, setSlots } from '../simple';

import selectDate from './selectDate';

const requestSlots = (
    productId: number | undefined,
    getTimeSlotsFunc: TGetTimeSlots,
    gaLabel?: string,
) => async(dispatch: TContextDispatch, getState: () => TInitialState) => {
    const {
        _requestedDays,
        _incomingData,
    } = getState();

    const providerId = cookies.load(PROVIDER_ID_COOKIE);

    if (!_incomingData) {
        throw new Error('Incoming data is not set');
    }

    const {
        numberOfDays,
        maxNumberOfDays,
    } = _incomingData;

    if (_requestedDays >= maxNumberOfDays) {
        return null;
    }

    dispatch(setIsLoading(true));

    const addingToStartDate = _requestedDays;
    let addingToEndDate = addingToStartDate + numberOfDays - 1; // 0,6; 7,13; 14,20; 21,27; 28,30;

    if (addingToEndDate > maxNumberOfDays) {
        addingToEndDate = maxNumberOfDays;
    }

    const dateFrom = dayjs(_incomingData.dateFrom).add(addingToStartDate, 'day').toDate();
    const dateTo = dayjs(_incomingData.dateFrom).add(addingToEndDate, 'day').toDate();

    dataLayerPush({
        category: _incomingData.gaCategory,
        action: 'getting_time_slots_start',
        label: gaLabel,
    });

    const body = getBodyForTimeSlotsRequest(getState(), dateFrom, dateTo, productId);

    const resp = await getTimeSlotsFunc(providerId, body);

    if (resp.isSuccess) {
        const slots = transformTimeSlots(Object.values(resp.payload.timeSlots));

        dataLayerPush({
            category: _incomingData.gaCategory,
            action: 'getting_time_slots_success',
            label: gaLabel,
        });

        batch(() => {
            dispatch(setSlots(slots));
            dispatch(setErrorMessage(''));
            // TS2345: Argument of type '(dispatch: TDispatch, getState: () => TInitialState) => void' is not
            // assignable to parameter of type 'IAction<string, unknown>'.
            // @ts-ignore
            if (Object.keys(resp.payload.timeSlots).length > 0) {
                dispatch(selectDate(Object.values(slots)[0].date));
                dispatch(requestSlotsAction(addingToEndDate + 1));
            }
        });
    } else {
        dispatch(setErrorMessage(resp.error.message));
        dataLayerPush({
            category: _incomingData.gaCategory,
            action: 'getting_time_slots_error',
            label: gaLabel || resp.error ? resp.error.message : 'нет описания',
        });
        captureException(resp.error);
    }

    dispatch(setIsLoading(false));
};

export default requestSlots;
